




























































































































































































































































import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import EventBus from '@/plugins/EventBus'
import { IRequestMessage, RequestMessage } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component
export default class FinanceiroGerenciamentoEquipes extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  visibleResults: number = 5
  formValido: boolean = true
  showModalEquipe: boolean = false
  showModalDelete: boolean = false
  loadDelete: boolean = false
  
  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get totalPaginas() {
    return Math.ceil(this.getRecebimentoStore.totalEquipesList / 10)
  }

  get equipesPaginadas() {
    return this.getRecebimentoStore.equipesAllList
  }

  get isEdit() {
    return this.getRecebimentoStore.isEditEquipe
  }

  set isEdit(value: boolean) {
    this.getRecebimentoStore.setIsEditEquipe(value)
  }

  get paginaAtual() {
    return this.getRecebimentoStore.paginaEquipes
  }

  set paginaAtual(value: number) {
    this.getRecebimentoStore.setPaginaEquipes(value)
  }

  get searchGerenciamentoEquipe() {
    return this.getRecebimentoStore.searchGerenciamentoEquipe
  }

  set searchGerenciamentoEquipe(value: string) {
    this.getRecebimentoStore.setSearchGerenciamentoEquipe(value)
  }

  get headersEquipes() {
    return [
      { text: 'Nome', value: 'nome', align: 'start', sortable: false },
      // { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false },
    ]
  }

  get nomeEquipe() {
    return this.getRecebimentoStore.nomeEquipe
  }

  set nomeEquipe(value: string) {
    this.getRecebimentoStore.setNomeEquipe(value)
  }

  get descricaoEquipe() {
    return this.getRecebimentoStore.descricaoEquipe
  }

  set descricaoEquipe(value: string) {
    this.getRecebimentoStore.setDescricaoEquipe(value)
  }

  get filtrarPorProcedimentos() {
    return this.getRecebimentoStore.filtrarPorProcedimentos
  }

  set filtrarPorProcedimentos(value: boolean) {
    this.getRecebimentoStore.setFiltrarPorProcedimentos(value)
  }

  get procedimentosEquipes() {
    return this.getRecebimentoStore.procedimentosEquipes
  }
  
  set procedimentosEquipes(value: string[]) {
    this.getRecebimentoStore.setProcedimentosEquipes(value)
  }

  get filtrarPorHospital() {
    return this.getRecebimentoStore.filtrarPorHospital
  }

  set filtrarPorHospital(value: boolean) {
    this.getRecebimentoStore.setFiltrarPorHospital(value)
  }

  get hospitalEquipe() {
    return this.getRecebimentoStore.hospitalEquipe
  }

  set hospitalEquipe(value: string) {
    this.getRecebimentoStore.setHospitalEquipe(value)
  }

  get procedimentos() {
    return this.getRecebimentoStore.procedimentosList
  }

  get hospitais() {
    return this.getRecebimentoStore.fontesPagadoras
  }

  get loadinDelete() {
    return this.loadDelete
  }

  set loadingDelete(value: boolean) {
    this.loadDelete = value
  }

  openModalDelete(item: any) {
    this.getRecebimentoStore.setDeleteId(item.id)
    this.showModalDelete = true
  }

  async aplicarFiltro(item: any) {
    this.searchGerenciamentoEquipe = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async filter() {
    this.paginaAtual = 1
    await this.getRecebimentoStore.getEquipesAll()
  }

  abrirModalCriar() {
    this.isEdit = false
    this.resetForm()
    this.showModalEquipe = true
  }

  async abrirModalEditar(equipe: any) {
    this.isEdit = true
    await this.getRecebimentoStore.setEquipeEdit(equipe)
    this.getRecebimentoStore.setEquipeId(equipe.id)
    this.showModalEquipe = true
  }

  async abrirModalProfissionais(equipe: any) {
    this.getRecebimentoStore.setModalProfissionais(true)
    this.getRecebimentoStore.setEquipeId(equipe.id)
    await this.getRecebimentoStore.getProfissionaisEquipeMedica()
    this.getRecebimentoStore.setModalTabelaProfissionais(true)
  }

  async abrirModalRegraEquipe(equipe: any) {
    this.getRecebimentoStore.setEquipeId(equipe.id)
    await this.getRecebimentoStore.getRegrasEquipeMedica()
    this.getRecebimentoStore.setModalTabelaRegras(true)
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.paginaAtual = pagina
    await this.getRecebimentoStore.getEquipesAll()
    EventBus.$emit('clearLoadingRequest')
  }

  fecharModalEquipe() {
    this.showModalEquipe = false
  }

  resetForm() {
    this.getRecebimentoStore.resetEquipeForm()
  }

  async deleteItem() {
    this.loadingDelete = true
    await this.getRecebimentoStore.deleteEquipeMedica()
    this.showModalDelete = false
    await this.getRecebimentoStore.getEquipesAll()
    this.loadingDelete = false
  }

  async salvarEquipe() {
    if (!(this.$refs.formEquipe as any).validate()) return
    const response = await this.getRecebimentoStore.salvarEquipe()
    if (response.success) {
      this.fecharModalEquipe()
      await this.getRecebimentoStore.getEquipesAll()
    }
  }

  formatData(date: string) {
    return new Date(date).toLocaleDateString('pt-BR')
  }

  async init() {
    await this.getRecebimentoStore.getEquipesAll()
    await this.getRecebimentoStore.getProcedimentosList()
    await this.getRecebimentoStore.getFontePagadoraAll()
    await this.getRecebimentoStore.getPrestadores({})
  }
  
  async mounted() {
    await this.init()
  }
  
}
